import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    PI_PRODUCT,
    PI_ATC,
    PI_ATC_LIST,
    PI_PHARMACEUTICAL_FORM,
    PI_PRESENTATION,
    PI_LIST,
    PI_EDIT,
} from "../../actions";

import {
    PIProductSuccess,
    PIProductError,
    PIAtcSuccess,
    PIAtcError,
    PIAtcListSuccess,
    PIAtcListError,
    PIPharmaceuticalFormSuccess,
    PIPharmaceuticalFormError,
    PIPresentationSuccess,
    PIPresentationError,
    PIListSuccess,
    PIListError,
    PIEditSuccess,
    PIEditError
} from '../../actions';

export function* watchPIProduct() {
    yield takeEvery(PI_PRODUCT, onPIProduct);
}

export function* watchPIAtcList() {
    yield takeEvery(PI_ATC_LIST, onPIAtcList);
}

export function* watchPIAtc() {
    yield takeEvery(PI_ATC, onPIAtc);
}

export function* watchPIPharmaceuticalForm() {
    yield takeEvery(PI_PHARMACEUTICAL_FORM, onPIPharmaceuticalForm);
}

export function* watchPIPresentation() {
    yield takeEvery(PI_PRESENTATION, onPIPresentation);
}

export function* watchPIList() {
    yield takeEvery(PI_LIST, onPIList);
}

export function* watchPIEdit() {
    yield takeEvery(PI_EDIT, onPIEdit);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onPIProductAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'productInfo/product', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPIAtcAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'productInfo/atc', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPIAtcListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'productInfo/atclist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPIPharmaceuticalFormAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'productInfo/pharmaceuticalform', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onPIPresentationAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'productInfo/presentation', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


const onPIListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'productInfo/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onPIEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'productInfo/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onPIProduct(data) {
    try {
        const response = yield call(onPIProductAsync, data.payload);
        yield put(PIProductSuccess(response.data));
    } catch (error) {
        yield put(PIProductError(error));
    }
}

function* onPIAtc(data) {
    try {
        const response = yield call(onPIAtcAsync, data.payload);
        yield put(PIAtcSuccess(response.data));
    } catch (error) {
        yield put(PIAtcError(error));
    }
}

function* onPIAtcList(data) {
    try {
        const response = yield call(onPIAtcListAsync, data.payload);
        yield put(PIAtcListSuccess(response.data));
    } catch (error) {
        yield put(PIAtcListError(error));
    }
}

function* onPIPharmaceuticalForm(data) {
    try {
        const response = yield call(onPIPharmaceuticalFormAsync, data.payload);
        yield put(PIPharmaceuticalFormSuccess(response.data));
    } catch (error) {
        yield put(PIPharmaceuticalFormError(error));
    }
}

function* onPIPresentation(data) {
    try {
        const response = yield call(onPIPresentationAsync, data.payload);
        yield put(PIPresentationSuccess(response.data));
    } catch (error) {
        yield put(PIPresentationError(error));
    }
}

function* onPIList(data) {
    try {
        const response = yield call(onPIListAsync, data.payload);
        yield put(PIListSuccess(response.data));
    } catch (error) {
        yield put(PIListError(error));
    }
}

function* onPIEdit(data) {
    try {
        const response = yield call(onPIEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(PIEditSuccess(response.data));
    } catch (error) {
        yield put(PIEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}


export default function* rootSaga() {
    yield all([
        fork(watchPIProduct),
        fork(watchPIAtc),
        fork(watchPIAtcList),
        fork(watchPIPharmaceuticalForm),
        fork(watchPIPresentation),
        fork(watchPIList),
        fork(watchPIEdit),
    ]);
}